<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table class=""
                                             :settings="tableConfig"
                                             :table-items="tableItems"
                                             @load-items="getTableData"
                                             @export="exportItems"
                                             ref="gofixTable">

                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:remark" slot-scope="row">
                                <div v-if="checkIsJson(row.item.remark)">
                                    <json-viewer
                                            :value="row.item.remark | isJson"
                                            :expand-depth="0"
                                            sort></json-viewer>
                                </div>
                                <div v-else v-html="row.item.remark"></div>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>

            <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.remark.title" hide-footer :centered="true" v-model="modals.remark.open" @hidden="hiddenModalRemark">
                <b-form class="formInvoice pb-10">
                    <b-row>
                        <b-col md="12">
                            <gofix-form-input label="Remark" v-model="modals.remark.data.remark"></gofix-form-input>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right">
                    <gofix-button label="APPLY" @click="saveActivity" :loading="modals.remark.loading" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
          <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.export.title" hide-footer :centered="true" v-model="modals.export.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
              <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.export.process}}</span>
              </b-progress-bar>
            </b-progress>
          </b-modal>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js';
    import JsonViewer from 'vue-json-viewer';

    export default {
        name: 'audit-trail-duty',
        data () {
            let filter =  JSON.parse(JSON.stringify(filters['activities']));
          filter.user_record_email = {
            type: "text", value: "", function: "ilike", with: []
          }
            return {
                modals:{
                    remark:{
                        open:false,
                        loading:false,
                        data:{
                            id:null,
                            remark: null
                        },
                        title: 'Add Remark'
                    },
                  export:{
                    open:false,
                    loading:false,
                    process:'Creating file csv',
                    title: 'Export Data'
                  }
                },
                tableConfig:{
                    name: 'audit-trail-duty',
                    controls:{
                        create: false,
                        delete: false,
                        update: false,
                        tableImport: false,
                        tableExport: true,
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: true,
                    sortColumn: "created_at",
                    sortDirection: "desc",
                },
                tableItems: [],
                activityType:"User duty",
                activityId:"",
            }
        },
        components: {JsonViewer},
        filters: {
            isJson(value) {
                try {
                    JSON.parse(value);
                } catch (e) {
                    return value;
                }
                return JSON.parse(value);
            },
        },
        created () {

        },

        methods:{
            /* ----Save data ----------------------------------------------------*/
            saveActivity(){
                this.modals.remark.loading = true;
                let params = {};

                let action = "create"
                let keyMessage= 'adding'
                if(this.modals.remark.data.id){
                    action = "update"
                    keyMessage = 'editing'
                    params = Object.assign({}, this.modals.remark.data);
                }else{
                    params = Object.assign({
                        work_item_type: this.activityType,
                        work_item_id: this.activityId,
                        action: "Remark"
                    }, this.modals.remark.data);
                }

                this.$store.dispatch(`ActivityLogsController/${action}`, params)
                    .then(response => {
                        this.modals.remark.loading = false;
                        this.modals.remark.open = false;
                        this.$refs.gofixTable.reloadTableKeepFilter();
                        this.$alertNotification(this.$notificationV2(keyMessage, 'activity_log'));
                    })
                    .catch(err => {
                        this.modals.remark.loading = false;
                    })
            },
            async clickToRowItem(item){
                if(!this.controls.update) return;
                if(item.remark && !this.checkIsJson(item.remark)){
                    this.modals.remark.data.id = item.id;
                    this.modals.remark.data.remark = item.remark;
                    this.modals.remark.open = true;
                }
            },
            /* ---- Get data ----------------------------------------------------*/
            async getTableData(callback){
                const { tableRequest , resolve,reject } = await callback();
                //tableRequest.filter.work_item_id.value = this.activityId;
                tableRequest.filter.work_item_type.value = this.activityType;
                tableRequest.type = "User duty"
                await this.$store.dispatch("ActivityLogsController/get", tableRequest)
                    .then(response => {
                        this.tableItems = response.data.data.items;
                        this.tableConfig.total = response.data.data.total;
                        resolve(response.data.data);
                    })
                    .catch(err => {
                        console.log(err);
                        this.$alertNotification("Can not load the items", "danger");
                        reject();
                    })
            },
            async deleteItems(callback){
                const { ids,filter, resolve,reject } = await callback();
                await this.$store.dispatch('ActivityLogsController/delete', ids)
                    .then(response => {
                        resolve(this.$notificationV2('deleting', 'activity_log'))
                    })
                    .catch(err => {
                        reject();
                    })
            },
            triggerReloadData(){
                this.$refs.gofixTable.reloadTableItems();
            },

            /* ---- Attributes ----------------------------------------------------*/
            hiddenModalRemark(){
                this.modals.remark.data.id = null;
                this.modals.remark.data.remark = null;
                this.modals.remark.title = 'Add Remark';
            },
            checkIsJson(item){
                if(!item) return false;
                try {
                    JSON.parse(item);
                } catch (e) {
                    return false;
                }
                return true;
            },
          async exportItems(){
            let params = JSON.parse(JSON.stringify(this.$refs.gofixTable.tableRequest));
            params.limit = -1;
            params.filter.work_item_type.value = this.activityType;
            let that = this;
            this.modals.export.open = true;
            this.modals.export.process = "Creating file csv";
            await global.axios('/api/audit-trail/export-duty-assignment', {
              method: "GET",
              params: params,
              responseType: 'blob',
              onDownloadProgress (progress) {
                that.modals.export.process = "Downloading";
              }
            })
                .then(response => {
                  const url = window.URL.createObjectURL(new Blob([response.data]));
                  const link = document.createElement('a');
                  link.href = url;
                  link.setAttribute('download', 'audit-trail-duty-assignment.csv'); //or any other extension
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                  this.modals.export.open = false
                })
                .catch(error => {
                  this.modals.export.open = false
                  console.log(error);
                });
          }
        }
    }
</script>
